module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "showPhoto",
    on: {
      "click": _vm.closeClick
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.url,
      "alt": "图片加载失败"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-624219a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/big-img.vue
// module id = 834
// module chunks = 2